import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { IntervalEnum } from '@modules/filters/enums';

const intervalDaysAmountBoundaries = {
  [IntervalEnum.TenMinutes]: 31,
  [IntervalEnum.Hour]: 186,
};

const exceedDaysNumberErrorMessages = {
  [IntervalEnum.TenMinutes]: '10 min interval is available for one month only',
  [IntervalEnum.Hour]: 'hour interval is available for 6 months only',
};

export function intervalCustomValidator(
  dateRangeControlName: string,
): ValidatorFn {
  return (intervalControl: AbstractControl): ValidationErrors | null => {
    if (!intervalControl.parent) {
      return null;
    }

    const dateRangeControl = intervalControl.parent.get(dateRangeControlName);
    if (!dateRangeControl) {
      return null;
    }

    const dateRangeValue = dateRangeControl.value;

    if (!Array.isArray(dateRangeValue) || dateRangeValue.length !== 2) {
      return null;
    }

    const [startDate, endDate] = dateRangeValue;

    if (!(startDate instanceof Date) || !(endDate instanceof Date)) {
      return null;
    }

    const intervalValue = intervalControl.value.value
      ? intervalControl.value.value
      : intervalControl.value;

    if (!intervalValue) {
      return null;
    }

    const timeDiff = Math.abs(endDate.getTime() - startDate.getTime());
    const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24)) + 1;

    if (intervalValue in intervalDaysAmountBoundaries) {
      const maxDays =
        intervalDaysAmountBoundaries[
          intervalValue as keyof typeof intervalDaysAmountBoundaries
        ];

      if (daysDiff > maxDays) {
        return {
          maxDays:
            exceedDaysNumberErrorMessages[
              intervalValue as keyof typeof exceedDaysNumberErrorMessages
            ],
        };
      }
    }

    return null;
  };
}
